import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IpTableComponent } from '../../components/ip-table/ip-table.component';
import { FnAccountInfoComponent } from './components/fn-account-info/fn-account-info.component';
import { FnAccountTransactionsComponent } from './components/fn-account-transactions/fn-account-transactions.component';
import { FnCardDataComponent } from './components/fn-card-data/fn-card-data.component';
import { FnCardImageComponent } from './components/fn-card-image/fn-card-image.component';
import { FnCardInfoComponent } from './components/fn-card-info/fn-card-info.component';
import { FnCardTransactionsComponent } from './components/fn-card-transactions/fn-card-transactions.component';
import { FnFiltersModalComponent } from './components/fn-filters-modal/fn-filters-modal.component';
import { FnPaymentsDoneComponent } from './components/fn-payments-done/fn-payments-done.component';
import { FnPaymentsOngoingComponent } from './components/fn-payments-ongoing/fn-payments-ongoing.component';
import { FnProvidersAccountsComponent } from './components/fn-providers-accounts/fn-providers-accounts.component';
import { FinanceRoutingModule } from './finance-routing.module';
import { FnBusinessPaydoneComponent } from './views/fn-business-finance/fn-business-paydone.component';
import { FnMyFinanceComponent } from './views/fn-my-finance/fn-my-finance.component';
import { FnPaymentDetailsComponent } from './components/fn-payment-details/fn-payment-details.component';
import { FnRequestCardModalComponent } from './components/fn-request-card-modal/fn-request-card-modal.component';
import { FnBlockCardModalComponent } from './components/fn-block-card-modal/fn-block-card-modal.component';
import { FnTablesComponent } from './components/fn-tables/fn-tables.component';
import { IpSearchInputComponent } from '../../components/ip-search-input/ip-search-input.component';
import { FnPayInvoicesComponent } from './components/fn-pay-invoices/fn-pay-invoices.component';
import { FnConsolidatedComponent } from './components/fn-consolidated/fn-consolidated.component';
import { FnConsolidatedDetailsComponent } from './components/fn-consolidated-details/fn-consolidated-details.component';
import { FnMobileTableHeaderComponent } from './components/fn-mobile-table-header/fn-mobile-table-header.component';
import { FnStatusModalComponent } from './components/fn-status-modal/fn-status-modal.component';
import { FnPaidOrdersComponent } from './views/fn-paid-orders/fn-paid-orders.component';
import { FnManagePayOrdersComponent } from './views/fn-manage-pay-orders/fn-manage-pay-orders.component';

@NgModule({
  declarations: [
    FnMyFinanceComponent,
    FnAccountTransactionsComponent,
    FnCardTransactionsComponent,
    FnAccountInfoComponent,
    FnCardInfoComponent,
    FnPaymentsDoneComponent,
    FnPaymentsOngoingComponent,
    FnProvidersAccountsComponent,
    FnCardImageComponent,
    FnCardDataComponent,
    FnBusinessPaydoneComponent,
    FnFiltersModalComponent,
    FnPaymentDetailsComponent,
    FnRequestCardModalComponent,
    FnBlockCardModalComponent,
    FnTablesComponent,
    FnPayInvoicesComponent,
    FnConsolidatedComponent,
    FnConsolidatedDetailsComponent,
    FnMobileTableHeaderComponent,
    FnStatusModalComponent,
    FnPaidOrdersComponent,
    FnManagePayOrdersComponent,
  ],
  imports: [
    CommonModule,
    FinanceRoutingModule,
    SharedModule,
    TranslateModule,
    MatIconModule,
    MatNativeDateModule,
    TranslateModule,
    MatSortModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IpTableComponent,
    IpSearchInputComponent,
  ],
  providers: [
    TranslateService,
    SharedModule,
    TranslateModule,
    DatePipe,
    CurrencyPipe,
  ],
})
export class FinanceModule {}
